/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Linked_ToastInputs */

const vi_shop_account_linked_toast = /** @type {(inputs: Shop_Account_Linked_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật liên kết khách ERP.`)
};

/**

* @param {Shop_Account_Linked_ToastInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_linked_toast = /** @type {((inputs?: Shop_Account_Linked_ToastInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Linked_ToastInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_linked_toast(inputs)
});